import { FilterBody } from '@yes.technology/react-toolkit'
import apiAsync from 'infrastructure/shared/api/api-async'
import { FilterResponse } from 'sitemodel/shared/types'

export async function postObjectsFilter<ResponseType>(
  payload: Partial<FilterBody>,
  showLoading: boolean
): Promise<FilterResponse<ResponseType>> {
  return await apiAsync.requestSync({
    endpoint: 'msPlatform',
    path: 'objects/_filter',
    method: 'POST',
    obj: payload
      ? {
          ...payload,
          data_storage: payload?.data_storage ?? 'published_with_fallback'
        }
      : payload,
    showLoading
  })
}
